import {
    Attachment,
    Button,
    FilesUploadIcon,
    Flex,
    Text,
    TrashCanIcon,
} from "@fluentui/react-northstar";
import React, { useState } from "react";
import { useRef } from "react";
import { uploadFile } from "../../api/uploads";
import { file_size_format } from "../../constants/maths";
import { ICON_FROM_EXTENSION } from "../../utils/functions";

const UploadFile = ({
    content,
    icon = <FilesUploadIcon />,
    onFileUploaded,
}) => {
    const input_ref = useRef();

    const [progress, setProgress] = useState(0);
    const [file, setFile] = useState(null);

    return (
        <Flex>
            {!file ? (
                <>
                    <input
                        ref={input_ref}
                        type="file"
                        hidden
                        onChange={(e) => {
                            const uploaded_file = e?.target?.files[0];
                            setFile(uploaded_file);
                            uploadFile(
                                uploaded_file,
                                setProgress,
                                onFileUploaded
                            );
                            return;
                        }}
                    />
                    <Button
                        content={content}
                        tinted
                        icon={icon}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            input_ref.current.click();
                        }}
                    />
                </>
            ) : (
                <Attachment
                    key={"file"}
                    icon={ICON_FROM_EXTENSION(file.filename || file.name)}
                    header={
                        <Text truncated content={file.filename || file.name} />
                    }
                    description={file_size_format(file.size)}
                    actionable
                    action={{
                        icon: <TrashCanIcon filled />,
                        onClick: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setFile(null);
                        },
                        title: "Supprimer le document",
                    }}
                    progress={progress}
                    style={{ maxWidth: "100%" }}
                />
            )}
        </Flex>
    );
};

export default UploadFile;
